const BabyBalloons = ({ className }: { className?: string }) => (
  <svg
    className={className}
    fill="none"
    height="150"
    viewBox="0 0 150 150"
    width="150"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_2716_3409"
        x1="95.0717"
        x2="126.701"
        y1="76.1796"
        y2="76.1796"
      >
        <stop stopColor="#009FC4" />
        <stop offset="0.74" stopColor="#00B08E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_2716_3409"
        x1="24.0006"
        x2="52.204"
        y1="62.2621"
        y2="62.2621"
      >
        <stop offset="0.23" stopColor="#FF6F55" />
        <stop offset="1" stopColor="#FF6FA5" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_2716_3409"
        x1="73.4846"
        x2="101.678"
        y1="62.2621"
        y2="62.2621"
      >
        <stop offset="0.13" stopColor="#00B08E" />
        <stop offset="0.27" stopColor="#00B577" />
        <stop offset="0.78" stopColor="#B9C400" />
        <stop offset="1" stopColor="#FFC900" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_2716_3409"
        x1="47.418"
        x2="78.8733"
        y1="75.9343"
        y2="75.9343"
      >
        <stop offset="0.3" stopColor="#FFC900" />
        <stop offset="1" stopColor="#FF6F55" />
      </linearGradient>
    </defs>
    <path
      d="M110.881 69.3794V110.641"
      stroke="#832669"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <path
      d="M126.496 58.7442C125.791 55.7275 122.57 54.1936 120.177 54.5515C117.763 54.9094 115.953 56.249 114.644 58.284C113.663 59.7975 112.701 61.3314 111.709 62.8346C111.372 63.3459 111.127 63.6015 110.881 63.622C110.636 63.6015 110.39 63.3357 110.053 62.8346C109.061 61.3314 108.1 59.7975 107.118 58.284C105.809 56.249 103.989 54.9094 101.586 54.5515C99.1928 54.1936 95.9716 55.7377 95.266 58.7442C94.7036 61.1473 95.399 63.2845 96.6159 65.2888C98.4974 68.3771 100.778 71.1893 102.925 74.0935C103.682 75.1161 104.06 76.2512 104.285 77.4987C104.868 80.6893 104.255 83.8798 104.388 87.0703C104.439 88.3588 104.572 89.637 104.93 90.8846C105.39 92.4799 106.893 93.7888 108.631 94.2388L107.875 95.5579C107.282 96.5907 108.028 97.869 109.214 97.869H112.558C113.744 97.869 114.491 96.5805 113.898 95.5579L113.141 94.2388C114.89 93.799 116.383 92.4901 116.843 90.8846C117.201 89.637 117.334 88.369 117.385 87.0703C117.508 83.8798 116.904 80.6893 117.487 77.4987C117.712 76.2512 118.091 75.1161 118.847 74.0935C120.995 71.1893 123.275 68.3771 125.157 65.2888C126.384 63.2845 127.079 61.1575 126.507 58.7442H126.496Z"
      fill="url(#paint0_linear_2716_3409)"
      stroke="#832669"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <path
      d="M53.0836 69.3794V110.641"
      stroke="#832669"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <path
      d="M38.1127 74.8707V110.641"
      stroke="#832669"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <path
      d="M87.5863 77.3761V110.641"
      stroke="#832669"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <path
      d="M48.4818 61.2702C46.9376 59.951 46.7945 59.6749 48.1647 58.0081C50.1179 55.6356 50.711 52.4144 49.8214 49.4795C47.6125 42.1781 40.3418 40 37.2433 40C33.9199 40 25.0539 40.6136 24.3381 51.8315C24.0415 56.5048 24.0415 64.5016 24.0006 69.226C23.9699 72.4983 25.0744 75.7093 27.273 78.1431C27.907 78.8385 28.5921 79.4418 29.3079 79.7997C30.7498 80.5156 32.2735 80.9246 33.879 81.1598C34.2982 81.2212 34.7277 81.2723 35.147 81.3132L34.6152 82.2335C34.0221 83.2664 34.7686 84.5446 35.9549 84.5446H39.5647C40.7509 84.5446 41.4974 83.2561 40.9043 82.2335L40.3316 81.2416C41.7735 81.0371 43.2051 80.6792 44.6061 80.1167C48.6351 78.4806 51.386 75.6275 52.0609 71.2508C52.654 67.3751 51.5598 63.8983 48.492 61.2906L48.4818 61.2702ZM40.1373 53.2734C40.1373 55.1652 38.8488 56.6889 37.2536 56.6889C35.6583 56.6889 34.3698 55.155 34.3698 53.2734C34.3698 51.3918 35.6583 49.8579 37.2536 49.8579C38.8488 49.8579 40.1373 51.3918 40.1373 53.2734ZM40.1373 68.2852C40.1373 70.177 38.8488 71.7007 37.2536 71.7007C35.6583 71.7007 34.3698 70.1668 34.3698 68.2852C34.3698 66.4036 35.6583 64.8697 37.2536 64.8697C38.8488 64.8697 40.1373 66.4036 40.1373 68.2852Z"
      fill="url(#paint1_linear_2716_3409)"
      stroke="#832669"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <path
      d="M97.9555 61.2702C96.4114 59.951 96.2682 59.6749 97.6385 58.0081C99.5917 55.6356 100.185 52.4144 99.2951 49.4795C97.0863 42.1781 89.8156 40 86.7171 40C83.3936 40 74.5277 40.6136 73.8118 51.8315C73.5153 56.5048 73.5153 64.5016 73.4744 69.226C73.4437 72.4983 74.5481 75.7093 76.7467 78.1431C77.3807 78.8385 78.0659 79.4418 78.7817 79.7997C80.2236 80.5156 81.7472 80.9246 83.3527 81.1598C83.772 81.2212 84.2015 81.2723 84.6208 81.3132L84.089 82.2335C83.4959 83.2664 84.2424 84.5446 85.4286 84.5446H89.0384C90.2246 84.5446 90.9711 83.2561 90.378 82.2335L89.8054 81.2416C91.2472 81.0371 92.6789 80.6792 94.0798 80.1167C98.1089 78.4806 100.86 75.6275 101.535 71.2508C102.128 67.3751 101.034 63.8983 97.9657 61.2906L97.9555 61.2702ZM89.6111 53.2734C89.6111 55.1652 88.3226 56.6889 86.7273 56.6889C85.1321 56.6889 83.8436 55.155 83.8436 53.2734C83.8436 51.3918 85.1321 49.8579 86.7273 49.8579C88.3226 49.8579 89.6111 51.3918 89.6111 53.2734ZM89.6111 68.2852C89.6111 70.177 88.3226 71.7007 86.7273 71.7007C85.1321 71.7007 83.8436 70.1668 83.8436 68.2852C83.8436 66.4036 85.1321 64.8697 86.7273 64.8697C88.3226 64.8697 89.6111 66.4036 89.6111 68.2852Z"
      fill="url(#paint2_linear_2716_3409)"
      stroke="#832669"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <path
      d="M78.8733 90.0564C78.9347 88.0828 78.495 86.1705 78.2495 84.2276C77.9632 81.9574 77.6053 79.6872 77.2065 77.4375C76.6441 74.3288 75.9794 71.2303 75.1204 68.1829C74.2103 64.9515 73.0547 61.8121 71.3879 58.8772C70.6721 57.6092 69.8028 56.5662 68.7496 55.8197C67.3486 54.705 65.3852 54.0096 63.2173 54.0096H63.0946C60.9266 54.0096 58.9632 54.705 57.5623 55.8197C56.509 56.5764 55.6398 57.6194 54.924 58.8772C53.2469 61.8121 52.1016 64.9515 51.1915 68.1829C50.3325 71.2303 49.6678 74.3288 49.1053 77.4375C48.6963 79.6872 48.3384 81.9472 48.0623 84.2276C47.8169 86.1705 47.4794 88.0828 47.4385 90.0564C47.3874 92.388 48.5634 93.6662 50.2813 94.2286L49.5246 95.5376C48.9315 96.5704 49.678 97.8487 50.8642 97.8487H54.2081C55.3944 97.8487 56.1409 96.5602 55.5477 95.5376L54.9342 94.4741C55.6602 94.3923 56.3454 94.2491 56.734 94.0139C58.2474 93.114 58.7996 91.6312 59.2393 90.0769C59.4541 89.3406 59.587 88.5737 59.8222 87.8374C60.0779 87.0193 60.6608 86.4875 61.4277 86.2932C61.5709 86.2523 62.4196 86.2421 63.1764 86.2421C63.9331 86.2421 64.7819 86.2626 64.925 86.2932C65.692 86.4875 66.2749 87.0193 66.5305 87.8374C66.7555 88.5737 66.8986 89.3304 67.1134 90.0769C67.5633 91.6312 68.228 93.247 69.7926 94.3411C72.3696 96.1409 78.7302 95.5989 78.904 90.0462L78.8733 90.0564ZM63.207 77.9079C61.6118 77.9079 60.3233 76.374 60.3233 74.4924C60.3233 72.6108 61.6118 71.0769 63.207 71.0769C64.8023 71.0769 66.0908 72.6108 66.0908 74.4924C66.0908 76.374 64.8023 77.9079 63.207 77.9079Z"
      fill="url(#paint3_linear_2716_3409)"
      stroke="#832669"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
  </svg>
)

export default BabyBalloons
